<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small" style='border: none;'>
        <div class="content-name">
          <h2 class="dp-ib">{{title}} 글쓰기</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="warning" icon="el-icon-document-copy" @click="goList" >목록</el-button>
            <el-button type="primary" icon="el-icon-document-add" @click="goWrite">등록</el-button>
          </el-form-item>
        </div>
      </el-form>
      <el-form ref="form" :model="form" label-width="120px" size="mini">
        <el-row :gutter="24">
          <el-col :span="14">
            <el-form-item label="제목">
              <el-input v-model="form.docNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="비밀번호">
              <el-input type="password" autocomplete="new-password" v-model="form.pwd" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" v-if="srcId2 === 'Notice' || srcId3 === 'Praise'">
          <el-col :span="24">
            <el-select
                style="width: 100%"
                v-model="form.asAgentsList"
                multiple
                filterable
                remote
                clearable
                :collapse-tags="form.asAgentsList.length === agentList.length - 1"
                @change="asAgentListChangeEvent"
                placeholder="수신자를 선택하세요.">
              <el-option
                  v-for="item in agentList"
                  :key="item.asAgentId"
                  :label="item.asAgentNm"
                  :value="item.asAgentId"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row v-if="srcId2 === 'Notice'">
          <el-col>
            <el-col :span="11">
              <el-form-item label="공지기간">
                <el-date-picker :disabled="srcId2 !== 'Notice'" type="date" placeholder="Pick a date" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="1" style="text-align: center;">-</el-col>
            <el-col :span="11">
              <el-form-item label-width="0px">
                <el-date-picker :disabled="srcId2 !== 'Notice'" type="date" placeholder="Pick a date" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <div class="ck-editor">
              <ckeditor
                  :editor="editor"
                  v-model="form.html"
                  :config="editorConfig"
                  @ready="onEditorReady"
                  @focus="onEditorFocus"
                  @blur="onEditorBlur"
                  @input="onEditorInput"
                  @destroy="onEditorDestroy"
              />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24" v-if="this.srcId2 == 'Notice' && this.srcId3 == 'Importance'">
          <el-col :span="10">
            <el-form-item label="관련 모델">
              <el-input v-model="form.modelNm" readonly></el-input>
              <el-input v-model="form.modelId" v-show="false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-button size="mini" type="primary" icon="el-icon-search" @click="searchModel"></el-button>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="첨부파일">
              <!-- <span>{{form.importanceText}}</span> -->
              <!-- :before-upload="onBeforeUpload" -->
              <el-upload
                v-model="form.files"
                class="upload-demo"
                multiple
                action=""
                :http-request="addFiles"
                :auto-upload="true"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :before-upload="onBeforeUpload"
                :on-exceed="handleExceed"
                :file-list="form.files"
                :limit="3">
                <el-button size="small" type="primary">파일선택</el-button>
                <div slot="tip" class="el-upload__tip">최대 파일 3개까지 업로드 가능합니다. (파일당 200MB 미만)</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
  </div>
</template>
<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ImageUploadAdapter from '@/libs/ckeditor/ImageUploadAdapter.js';

import _ from "lodash";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import ModelSelectModal from "@/components/AS/NormalConsult/Modal/ModelSelectModal";

export default {
  name:'boardMngRead',
  props:['custParam','title'],
  data(){
    return {
      // title:'',
      editor: ClassicEditor,
      editorData: '<p> 에디터에 데이터를 입력하세요. </p>',
      editorConfig: {
        language: 'en',
        extraPlugins: [ ImageUploadAdapter ]
      },
      srcId1:"",
      srcId2:"",
      srcId3:"",
      // boardInfo:{},
      form:{
        asAgentsList: [],
        asAgentsListAll:[],
        approvalYn : "",
        confirmCnt : "",
        content : "",
        createDt : "",
        creatorGroupUid : "",
        creatorId : "",
        creatorNm : "",
        deleteYn : "",
        docId : "",
        docIdx : "",
        docLvl : "",
        docNm : "",
        docNo : "",
        docPath : "",
        endDt : this.$moment(new Date()).add(7, 'days').format('YYYY-MM-DD'),
        endDtText : "",
        html : "",
        importance : "",
        importanceText : "",
        ip : "197.200.90.126",
        noticeYn : "Y",
        parentId : "",
        publicYn : "",
        pwd : "",
        readCnt : "",
        sortPath : "",
        srcId1 : "Home",
        srcId2 : "Notice",
        srcId3 : "",
        srcId4 : "",
        startDt : this.$moment(new Date()).format('YYYY-MM-DD'),
        startDtText : "",
        asAgentId : "",
        updateDt : "",
        updatorId : "",
        modelId : 0,
        modelNm : "",
        files: [],
      },
      defForm:{
        approvalYn : "",
        confirmCnt : "",
        content : "",
        createDt : "",
        creatorGroupUid : "",
        creatorId : "",
        creatorNm : "",
        deleteYn : "",
        docId : "",
        docIdx : "",
        docLvl : "",
        docNm : "",
        docNo : "",
        docPath : "",
        endDt : "9999-12-31",
        endDtText : "",
        html : "",
        importance : "",
        importanceText : "",
        ip : "197.200.90.126",
        noticeYn : "Y",
        parentId : "",
        publicYn : "",
        pwd : "",
        readCnt : "",
        sortPath : "",
        srcId1 : "Home",
        srcId2 : "Notice",
        srcId3 : "",
        srcId4 : "",
        startDt : "1999-01-01",
        startDtText : "",
        asAgentId : "",
        updateDt : "",
        updatorId : "",
        modelId : "",
        modelNm : "",
      },
      admin:{
        id:'',
        boardCd:'',
        boardSubCd:'',
        bSubject:'답변',
        bContent:'',
        attribute1:'',
        attribute2:'',
        attribute3:'',
        bReply:'N'
      },
      agentList:[],
      agentListTemp:{},
      adminR:[],
      resp:'',
      files:[],
      refreshYn:'',
      editorOptions : {
        theme:'bubble'
      }
    }
  },
  created(){
    //this.boardInfo = this.$route.params.boardInfo;
    //this.title = this.this.$route.params.title;
  },
  beforeMount() {
    this.getParameter();
  },
  mounted(){

    this.setInfo();
    this.getAgentList();

    if(this.srcId3 == 'Quality' && this.form.docId === '' ){  // 게시판이 품질정보서 게시판일경우 양식 호출
      this.$store.commit('loading')
      this.$http.post(`/api/boardMng/detail`,{
        companyId: this.$store.state.loginInfo.compCd,
        docId: 23332,
        processTime : ""
      })
      .then(response => {
        this.form.html = response.data[0].html;
      }).finally(() => {
        this.$store.commit('finish')
      });
    }

    if(this.srcId3 == 'ProductChange' && this.form.docId === '' ){  // 게시판이 제품교환 게시판일경우 양식 호출
      this.$store.commit('loading')
      this.$http.post(`/api/boardMng/detail`,{
        companyId: this.$store.state.loginInfo.compCd,
        docId: 23333,
        processTime : ""
      })
          .then(response => {
            this.form.html = response.data[0].html;
          }).finally(() => {
        this.$store.commit('finish')
      });

    }

    if(this.custParam.docId) {
      this.$http.post(`/api/boardMng/file/list`,{
        companyId: this.$store.state.loginInfo.compCd,
        srcId1: "DOC",
        srcId2: this.custParam.docId,
        srcId3: "",
        srcId4: "",
        processTime : ""
      })
      .then(res => {
         this.form.files = res.data;
        //  .map(x => {
        //   return new File([new Blob([x], { type: 'blob' })], x.name)
        // })
      })
      .finally(() => {
        this.$store.commit('finish');
      })
    }
    // if(!this.boardId){
    //   this.boardId = this.$store.state.board.boardId;
    // }
    // if(!this.title){
    //   this.title = this.$store.state.board.title;
    // }
    // this.getBoardDetail();
    // this.getFileList();
  },
  methods: {
    asAgentListChangeEvent(e) {
      const allCheckData = this.form.asAgentsList.find(data => data === 9999);
      if(allCheckData === 9999) {
        if (this.form.asAgentsList.length === this.agentList.length) {
          this.form.asAgentsList = [];
        } else {
          this.form.asAgentsList = [];
          this.agentList.forEach(x => {
            if (x.asAgentId !== 9999) {
              this.form.asAgentsList.push(x.asAgentId);
            }
          })
        }
      }
    },
    getParameter(){
      this.parameter = this.$menu.getGrants().parameter?.split("&");
      this.srcId1 = this.parameter[0]?.substring(this.parameter[0]?.indexOf('=')+1); // 콜센터,센터 구분
      this.srcId2 = this.parameter[1]?.substring(this.parameter[1]?.indexOf('=')+1); // 공지,일반 구분
      this.srcId3 = this.parameter[2]?.substring(this.parameter[2]?.indexOf('=')+1); // 게시판 종류 구분
    },
    // initEditor(editor) {
    //   console.log("init")
    //   editor.editing.view.change((writer)=> {
    //     writer.setStyle("height", "400px", editor.editing.view.document.getRoot())
    //   });
    // },
    getBoardDetail() {
      // this.$http.get(`/api/board/boardDetail/`+this.boardId)
      // .then(respones=>{
      //     this.form = respones.data
      //     this.admin.boardCd = this.form.boardCd
      //     this.admin.attribute3 = this.form.id
      //     if(this.form.bReply=='Y'){
      //         this.$http.get(`/api/board/boardReply/${this.boardId}`)
      //         .then(respones=>{
      //             this.adminR = respones.data;
      //         })
      //     }
      // })
    },
    searchModel(){
      /** 모델선택 */
      let vm = this;
      this.$modal.open({
        width: 800,
        component: ModelSelectModal,
        parent: this,
        props: {
          data: {
            custId : this.form.custId ? this.form.custId : '0'
          },
        },
        events: {
          close(param) {
            vm.form.modelNm = param.data.modelNm /** 모델명 */
            vm.form.modelId = param.data.modelId /** 모델ID */
          },
        }
      });

    },
    selectType(){
      // let val = '';
      // if(this.srcId2 == 'Freeboard' && this.srcId3 == 'Normal'){
      //   val = '';
      // }else if(this.srcId2 == 'Notice' && this.srcId3 == 'Normal'){
      //   val = this.srcId3;
      // }else if(this.srcId2 == 'Notice' && this.srcId3 == 'Tech'){
      //   val = 'Importance';
      // }else{
      //   val = this.srcId3;
      // }
      return this.srcId3;
    },
    goList() {
      this.cancel();
      this.viewType = 'list';
      this.$emit('viewType');
    },
    goRefresh(){
      this.cancel();
      this.viewType = 'list';
      this.$emit('refresh');
    },
    goWrite(){
      if(!this.form.docNm) {
        this.$swal({type: 'warning', text: '제목을 입력해주세요.'})
        return;
      }
      
      if(!this.form.html) {
        this.$swal({type: 'warning', text: '내용을 입력해주세요.'})
        return;
      }

      if(!this.form.pwd) {
        this.$swal({type: 'warning', text: '비밀번호를 입력해주세요.'})
        return;
      }

      // if(this.srcId2 === 'Notice') {
      //   console.log("this.form.asAgentIdthis.form.asAgentId", this.form.asAgentId)
      //   if(this.form.asAgentId.length < 1) {
      //     this.$swal({type: 'warning', text: '수신자를 선택하세요.'})
      //     return;
      //   }
      // }

      const boardInfo = this.form;
      // content에는 html 태그 제거하여 저장
      this.form.content =  this.form.html.replace(/<[^>]*>?/g, '');

      if(!boardInfo.docId){
        this.$store.commit('loading');
        //저장 시작
        this.$http
            .put('/api/boardMng/save',{
              companyId: this.$store.state.loginInfo.compCd,
              srcId1: this.form.srcId1,
              srcId2: this.srcId2,
              srcId3: this.form.srcId3,
              srcId4: this.form.srcId4,
              parentId: 0,
              docIdx: 0,
              noticeYn: this.form.noticeYn,
              docNm: this.form.docNm,
              content: this.form.content,
              html: this.form.html,
              importance: this.selectType(),
              startDt: this.form.startDt,
              endDt: this.form.endDt,
              ip: this.form.ip,
              approvalYn :this.form.approvalYn,
              pwd: this.form.pwd,
              asAgentIds: this.form.asAgentsList.join(','),
              creatorId: this.$store.state.loginInfo.id,
              modelId: this.isEmpty(this.form.modelId) == "" ? 0 : this.form.modelId,
              modelNm: this.isEmpty(this.form.modelNm) == "" ? 0 : this.form.modelNm,
              processTime: "",
              docId:0,
              docNo:0
            })
            .then(response => {
              
              if(this.form.files.length > 0) {
                this.boardFileUpload(response.data.docId, this.form.files);
              }
              
              this.$swal({ type: 'success', text: response.data.errMsg })
              .then( _ => {
                this.cancel();
                this.goRefresh();
                this.$store.commit('setBoardRefresh', true);
              });
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            })
            .finally( _ => {
              this.$store.commit('finish');
            });
      }
      else{
        this.$store.commit('loading');
        //수정 시작
        this.$http
            .put('/api/boardMng/update',{
              companyId: this.$store.state.loginInfo.compCd,
              docId:this.form.docId,
              noticeYn: this.form.noticeYn,
              docNm: this.form.docNm,
              content: this.form.content,
              html: this.form.html,
              importance: this.selectType(),
              startDt: this.form.startDt,
              endDt: this.form.endDt,
              approvalYn :this.form.approvalYn,
              asAgentIds: this.form.asAgentsList.join(','),
              updatorId: this.$store.state.loginInfo.id,
              modelId: this.isEmpty(this.form.modelId) == "" ? 0 : this.form.modelId,
              modelNm: this.isEmpty(this.form.modelNm) == "" ? 0 : this.form.modelNm,
              processTime: ""
            })
            .then(response => {
              if(this.form.files.length > 0) {
                this.boardFileUpload(this.form.docId, this.form.files);
              }
              
              this.$swal({ type: 'success', text: '수정되었습니다.' })
              .then( _ => {
                this.cancel();
                this.goRefresh();
                this.$store.commit('setBoardRefresh', false);
              });
              // this.$swal({ type: 'success', text: '저장되었습니다.' });
              // this.cancel();
              // this.goRefresh();
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            })
            .finally( _ => {
              this.$store.commit('finish');
            });

      }
    },
    cancel(){
      // CatInfo 초기화
      this.form = _.clone(this.defForm);
    },
    getAgentList(){
      // this.$http.post(`/api/boardMng/agent/list`,{
      //   companyId: this.$store.state.loginInfo.compCd,
      //   siNm: "",
      //   guNm: "",
      //   dongNm: "",
      //   statusYn: "Y",
      //   processTime : ""
      // })
      // .then(response => {
      //   this.agentList = response.data;
      // }).finally(() => {
      //   this.$store.commit('finish')
      // });

      this.$http.post(`/api/boardMng/area/agent/list`)
          .then(response => {
            this.agentList = response.data;
            this.agentList.unshift({asAgentId: 9999, asAgentNm: '전체'});
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    getFileList(){
      // this.$http.get(`/api/board/file/list/${this.boardId}`)
      // .then(respones=>{
      //     this.files = respones.data.files
      // })
    },
    goDelete(){
      this.$http
          .put('/api/boardMng/delete',{
            companyId: this.$store.state.loginInfo.compCd,
            docId:this.form.docId,
            updatorId: this.$store.state.loginInfo.id,
            processTime: ""
          })
          .then(response => {
            this.$swal({ type: 'success', text: '저장되었습니다.' });
            this.goRefresh();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });

    },
    typeSwitch(type){
      switch (type){
        case 'Normal':
          return type ='일반공지';
        case 'Importance':
          return type ='기술공지';
        case 'Quality':
          return type ='품질정보서';
        case 'ProductChange':
          return type ='제품교환';
        case '일반공지사항':
          return type ='Normal';
        case '기술공지사항':
          return type ='Importance';
        case '품질정보서게시판':
          return type ='Quality';
        case '제품교환게시판':
          return type ='ProductChange';
      }
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    addReply(){
      // if(!this.admin.bContent){
      //     this.$swal({type: 'warning', text: '내용을 입력해 주세요.'});
      //     return false;
      // }
      // this.form.bReply='Y'
      // this.$http.put(`/api/board/updateBoardDetail/${this.form.id}`, this.form)
      //
      // this.$http.post(`/api/board/addBoard`, this.admin)
      // .then(response=>{
      //     console.log("댓글 저장")
      //     this.resp = response.data;
      //     this.$swal({
      //         type: 'success',
      //         text: '댓글 등록완료.'
      //     }).then(() => {
      //         this.$router.push({
      //             name: 'ListSuggest',
      //         })
      //     })
      // })
    },
    onEditorReady(eventInfo) {
      eventInfo.editing.view.change((writer)=> {
        writer.setStyle("height", "400px", eventInfo.editing.view.document.getRoot())
      });
    },
    onEditorFocus(eventInfo, data ) {
      // console.log('onEditorFocus', eventInfo, data);
    },
    onEditorBlur(eventInfo, data ) {
      // console.log('onEditorBlur', eventInfo, data);
    },
    onEditorInput(eventInfo, batch) {
      // console.log('onEditorInput', eventInfo, batch);
      //Corresponds to the change:data editor event. See the v-model directive to learn more.
    },
    onEditorDestroy(eventInfo) {
      // console.log('onEditorDestroy', eventInfo);
    },
    setInfo() {
      this.custParam.modelId = this.isEmpty(this.custParam.modelId);
      this.custParam.modelNm = this.isEmpty(this.custParam.modelNm);
      Object.assign(this.form, this.custParam);
      this.form.importanceText = this.typeSwitch(this.form.importance);
      this.form.startDtText = this.getDateFormat(this.form.startDt);
      this.form.endDtText = this.getDateFormat(this.form.endDt);
      this.form.importance = this.typeSwitch(this.title);
    },
    //파일첨부 관련 메서드 s
    async boardFileUpload(docId, files){
      const formData = new FormData();
      _.forEach(this.form.files, file => {
        formData.append('files', file)
      })
      return await this.$http.post(`/api/board/file/addFiles/${docId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    addFiles(file, fileList) {
          this.form.files.push( file.file );
          
    },
    beforeRemove(file, fileList) {
      console.log("file check", file.fileId)
      if(file.fileId) {
        return this.$confirm(`${ file.name } 파일을 삭제 하시겠습니까?`);
      } else {
        const isLt200M = file.size / 1024 / 1024 < 200;
        if(!isLt200M) {
          return this.$message.error('파일은 200MB를 초과할 수 없습니다.');
        }
        //name
        this.form.files.splice(this.form.files.indexOf(file.uid) ,1)
        return this.$message.error('삭제되었습니다.');
      }
    },
    handleRemove(file, fileList) {
      if(file.fileId) {
        this.$http.post('/api/board/file/removeFile', Object.assign(file, {fileNm: file.name}))
        .then(response => {
          this.$swal({
            type: 'success',
            text: `${response.data}`
          });
        })
        .catch(err => {
          console.error(err);
        })
        .finally(()=> {
          this.form.files.splice(this.form.files.indexOf(file.fileId) ,1)
        })
      } else {
        return ;
      }
    },
    onBeforeUpload(file, fileList) {
      const isLt200M = file.size / 1024 / 1024 < 200;

      if (!isLt200M) {
        this.$message.error('파일은 200MB를 초과할 수 없습니다.');
      }

      return isLt200M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`총 파일은 3개까지 업로드 가능합니다.`);
    },
    allAgentList(){
      // const asAgentsListStr = this.form.asAgentsList.join(',');
      // if(asAgentsListStr.indexOf('9999') !== -1){
      //   this.form.asAgentsList = [];
      //   this.agentList.forEach(x=>{
      //     // this.form.asAgentsList.push(x.asAgentId);
      //     this.form.asAgentsListAll.push(x.asAgentId);
      //   })
      //   this.form.asAgentsList.push('전체');
      // } else if (asAgentsListStr.length > 50) {
      //   this.form.asAgentsList.splice(',').forEach(x=> {
      //     this.form.asAgentsListAll.push(x);
      //   })
      //   this.form.asAgentsList.push('전체')
      // }
    }
    //파일첨부 관련 메서드 e
  },
  watch: {
    custParam() {
      this.setInfo();
    },
    // 'form.asAgentsList'(){
    //   this.allAgentList();
    // }
  }
}
</script>
<style lang="scss" scoped>
.ck-editor__editable_inline {
  min-height: 400px;
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px;
  border-radius: 5px;
}
.el-row {
  border-bottom: 1px solid #d7d7d7;
  margin-top: 7px;
  &:last-child {
    border-bottom: none;
  }
}
</style>
